import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import every from 'lodash/every';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import { Alert, Button, Clearfix, Col, Panel, Row, Well } from 'react-bootstrap';
import ManifestTimeline from '../../../../components/ManifestTimeline/index';
import CollectionSelectionInfo from '../components/generic/CollectionSelectionInfo';
import ManifestInfo from '../components/generic/ManifestsInfo';
import EmaSmaModal from '../components/generic/EmaSmaModal';
import SmallLoader from '../../../../components/SmallLoader';
import {
    saveJourneyBuilderAnalysisData,
    unlinkSmaEma,
    silentFetchAbnormalityAnalysis,
    getIsSilentlyFetching,
} from '../../analysisDuck';
import { post } from '../../../../shared/http/request';
import { formatDate } from '../../../../shared/utils/date';
import { formatSupplier } from '../../../../shared/utils/run';
import { replaceArrow } from '../../../../shared/utils/string';

class ManifestGroupInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkSameJourneyPending: false,
            collectionDate: '',
            collectionRoutes: [],
            collectionTimeline: {},
            isLoadingCollectionRoutes: false,
            isLoadingCollectionTimeline: false,
            selectedCollectionRunId: '',
            selectedManifests: {},
            selectedManifestIdForEMALinking: '',
            selectedCollectionRunManifestId: '',
            showEmaModal: false,
            timelineKey: Math.random(),
        };
    }

    handleCollectionDateChange = collectionDate => {
        this.setState(() => ({
            collectionDate: collectionDate,
            collectionRoutes: [],
            isLoadingCollectionRoutes: true,
        }));
        const { manifestGroup } = this.props;
        if (moment(collectionDate, 'DD-MM-YYYY', true).isValid()) {
            post(`/api/abnormality/manifests/collection-routes`, {
                collectionDate: moment(collectionDate).format('YYYY-MM-DD'),
                emcDockCode: manifestGroup.manifests[0].manifest.emcDockCode,
                supplierCode: manifestGroup.manifests[0].manifest.supplierCode,
                supplierPlantCode: manifestGroup.manifests[0].manifest.supplierPlantCode,
            }).then(
                response =>
                    this.setState(() => ({
                        collectionRoutes: response.collectionRoutes,
                        isLoadingCollectionRoutes: false,
                    })),
                () =>
                    this.setState(() => ({
                        isLoadingCollectionRoutes: false,
                    }))
            );
        }
    };

    handleCollectionRouteChange = e => {
        let selectedCollectionRunId = e.target.value;
        this.setState(() => ({
            collectionTimeline: {},
            selectedCollectionRunManifestId: '',
            isLoadingCollectionTimeline: true,
            selectedCollectionRunId: selectedCollectionRunId,
        }));
        const { manifestGroup } = this.props;
        post(`/api/abnormality/manifests/collection-timelines`, {
            collectionRunId: selectedCollectionRunId,
            emcDockCode: manifestGroup.manifests[0].manifest.emcDockCode,
            supplierCode: manifestGroup.manifests[0].manifest.supplierCode,
            supplierPlantCode: manifestGroup.manifests[0].manifest.supplierPlantCode,
        }).then(
            response =>
                this.setState(() => ({
                    collectionTimeline: response,
                    isLoadingCollectionTimeline: false,
                    selectedCollectionRunManifestId: response.modelManifestId,
                })),
            () =>
                this.setState(() => ({
                    isLoadingCollectionTimeline: false,
                    selectedCollectionRunId: '',
                }))
        );
    };

    resetCollectionSelection = () => {
        this.setState(() => ({
            collectionDate: '',
            collectionRoutes: [],
            collectionTimeline: {},
            selectedCollectionRunId: '',
            selectedCollectionRunManifestId: '',
            timelineKey: Math.random(),
        }));
    };

    handleSelectManifest = (row, isSelected) => {
        let selectedManifests = Object.assign({}, this.state.selectedManifests);

        if (isSelected) {
            selectedManifests[row.manifest.manifestId] = {
                manifestId: row.manifest.manifestId,
                emaSmaManifestId: row.manifest.emaSmaManifest
                    ? row.manifest.emaSmaManifest.manifestId
                    : null,
            };
        } else {
            delete selectedManifests[row.manifest.manifestId];
        }

        this.setState({
            selectedManifests: selectedManifests,
        });
    };

    handleSelectAllManifests = (isSelected, rows) => {
        let selectedManifests = {};

        if (isSelected) {
            rows.forEach(
                row =>
                    (selectedManifests[row.manifest.manifestId] = {
                        manifestId: row.manifest.manifestId,
                        emaSmaManifestId: row.manifest.emaSmaManifest
                            ? row.manifest.emaSmaManifest.manifestId
                            : null,
                    })
            );
        }
        this.setState({
            selectedManifests: selectedManifests,
        });
    };

    toggleEmaPopup = manifestId => {
        this.setState(() => ({
            showEmaModal: !this.state.showEmaModal,
            selectedManifestIdForEMALinking: !this.state.showEmaModal ? manifestId : '',
        }));
    };

    unlinkEma = manifestId => {
        this.props.unlinkSmaEma(manifestId).then(() => {
            //TODO: needs to be a sse triggered refetch instead of a manually delayed one...
            this.props.silentFetchAbnormalityAnalysis(this.props.abnormalityId);
        });
    };

    startJourneyBuilder = (manifests, isEmaSma = false) => {
        const collectionRoute = find(this.state.collectionRoutes, [
            'runId',
            this.state.selectedCollectionRunId,
        ]);

        if (isEmaSma) {
            const allManifestsLinked = every(manifests, m => !isEmpty(m.emaSmaManifestId));
            if (!allManifestsLinked) {
                toastr.error(
                    'All manifests must be linked before proceeding to the EMA/SMA journey builder.'
                );
                return false;
            }
        }

        this.setState(() => ({ checkSameJourneyPending: true }));

        post(`/api/abnormality/manifests/have-same-journey`, {
            manifestIds: map(manifests, m => (isEmaSma ? m.emaSmaManifestId : m.manifestId)),
        }).then(
            () => {
                this.setState(() => ({ checkSameJourneyPending: false }));
                this.props.saveJourneyBuilderAnalysisData({
                    abnormalityId: this.props.abnormalityId,
                    manifests: manifests,
                    isEmaSma: isEmaSma,
                    collectionManifestId: this.state.selectedCollectionRunManifestId,
                    collectionRunId: this.state.selectedCollectionRunId,
                    collectionDate: this.state.selectedCollectionRunId
                        ? formatDate(this.state.collectionDate)
                        : '',
                    collectionRoute: this.state.selectedCollectionRunId
                        ? `${collectionRoute.routeCode} - ${formatDate(
                              collectionRoute.runDate
                          )} - ${collectionRoute.runSequence}`
                        : '',
                    collectionSupplier: formatSupplier({
                        supplierCode: this.props.manifestGroup.manifests[0].manifest.supplierCode,
                        supplierPlantCode: this.props.manifestGroup.manifests[0].manifest
                            .supplierPlantCode,
                    }),
                    collectionEmcDock: this.props.manifestGroup.manifests[0].manifest.emcDockCode,
                });

                let route = {
                    pathname: this.props.location.pathname + '/journeyBuilder',
                };
                this.props.router.push(route);
            },
            error => {
                toastr.error(
                    error.message ||
                        'Selected manifests do not follow the same journey... Please adjust your selection.'
                );
                this.setState(() => ({ checkSameJourneyPending: false }));
            }
        );
    };

    render() {
        let { manifestGroup, abnormalityId, isSilentlyFetching } = this.props;
        let {
            checkSameJourneyPending,
            collectionDate,
            collectionRoutes,
            collectionTimeline,
            error,
            isLoadingCollectionRoutes,
            isLoadingCollectionTimeline,
            showEmaModal,
            selectedCollectionRunId,
            selectedManifests,
            selectedManifestIdForEMALinking,
            timelineKey,
        } = this.state;
        return (
            <div>
                <Well>
                    <h4>Manifest Group {replaceArrow(manifestGroup.name)}</h4>
                    <Panel>
                        <ManifestTimeline
                            previousRun={manifestGroup.previousRun}
                            plannedRun={manifestGroup.plannedRun}
                            nextRun={manifestGroup.nextRun}
                        />
                    </Panel>
                    <CollectionSelectionInfo
                        manifestGroup={manifestGroup}
                        collectionDate={collectionDate}
                        onDateChange={this.handleCollectionDateChange}
                        isLoadingCollectionRoutes={isLoadingCollectionRoutes}
                        collectionRoutes={collectionRoutes}
                        selectedCollectionRunId={selectedCollectionRunId}
                        onCollectionRouteChange={this.handleCollectionRouteChange}
                        resetCollectionSelection={this.resetCollectionSelection}
                    />
                    <Panel>
                        {isLoadingCollectionTimeline ? (
                            <p style={{ textAlign: 'center' }}>Loading timeline...</p>
                        ) : (
                            <ManifestTimeline
                                key={timelineKey}
                                previousRun={
                                    collectionTimeline.plannedRun
                                        ? collectionTimeline.previousRun
                                        : manifestGroup.previousRun
                                }
                                plannedRun={
                                    collectionTimeline.plannedRun
                                        ? collectionTimeline.plannedRun
                                        : manifestGroup.plannedRun
                                }
                                nextRun={
                                    collectionTimeline.plannedRun
                                        ? collectionTimeline.nextRun
                                        : manifestGroup.nextRun
                                }
                            />
                        )}
                    </Panel>
                    <Row>
                        <Col sm={12}>{error && <Alert bsStyle={'danger'}>{error}</Alert>}</Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <ManifestInfo
                                manifests={manifestGroup.manifests}
                                handleSelect={this.handleSelectManifest}
                                handleSelectAll={this.handleSelectAllManifests}
                                toggleEmaPopup={this.toggleEmaPopup}
                                unlinkEma={this.unlinkEma}
                                showEmaButtons={true}
                                linkUnlinkEmaSmaPending={isSilentlyFetching}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Button
                                bsStyle="success"
                                style={{ marginRight: 15, minWidth: 200 }}
                                disabled={isEmpty(selectedManifests) || checkSameJourneyPending}
                                onClick={() => this.startJourneyBuilder(selectedManifests)}
                            >
                                {checkSameJourneyPending ? (
                                    <SmallLoader noMargin tiny />
                                ) : (
                                    'Create Original Manifest Recovery Action'
                                )}
                            </Button>
                            <Button
                                bsStyle="success"
                                style={{ minWidth: 160 }}
                                disabled={isEmpty(selectedManifests) || checkSameJourneyPending}
                                onClick={() => this.startJourneyBuilder(selectedManifests, true)}
                            >
                                {checkSameJourneyPending ? (
                                    <SmallLoader noMargin tiny />
                                ) : (
                                    'Create EMA/SMA Recovery Action'
                                )}
                            </Button>
                        </Col>
                    </Row>
                    <Clearfix />
                </Well>
                <EmaSmaModal
                    showEmaModal={showEmaModal}
                    hideEmaModal={this.toggleEmaPopup}
                    selectedManifests={selectedManifests}
                    selectedManifestId={selectedManifestIdForEMALinking}
                    abnormalityId={abnormalityId}
                />
            </div>
        );
    }
}

ManifestGroupInfo.propTypes = {
    manifestGroup: PropTypes.object,
};
ManifestGroupInfo.defaultProps = {};

export default withRouter(
    connect(state => ({ isSilentlyFetching: getIsSilentlyFetching(state) }), {
        saveJourneyBuilderAnalysisData,
        unlinkSmaEma,
        silentFetchAbnormalityAnalysis,
    })(ManifestGroupInfo)
);
